var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1277"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1277"
    },
    "bundlingPackage": "pricing-pages-ui-public-app",
    "bundlingPackageVersion": "static-1.15796",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};